import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";
import { routes } from "@/app/routes/paths";

export const RegistrationSuccessPage = ({ period }: { period: string }) => {
	return (
		<Card className="w-full text-center border-none light:bg-transparent shadow-transparent">
			<CardHeader className="flex flex-col items-center space-y-4 pt-8">
				<CheckCircle className="w-16 h-16 text-green-500 animate-bounce" />
				<CardTitle className="text-2xl font-bold dark:text-white">Registration Already Submitted!</CardTitle>
				<CardDescription className="text-[16px] text-gray-500 dark:text-gray-300">
					Your annual resident registration for <strong>{period}</strong> has been submitted successfully.
				</CardDescription>
			</CardHeader>

			<CardContent className="flex flex-col items-center space-y-4 mt-4 px-80">
				<p className="text-[18px] text-gray-600 dark:text-gray-400">
					You will receive an email confirmation shortly. Please keep a copy for your records.
				</p>

				<Button
					variant="default"
					className="mt-25"
					onClick={() => window.location.href = routes.BASE_APP_URL}
				>
					Go to Dashboard
				</Button>
			</CardContent>
		</Card>
	);
};
